/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Divider, Flex, Text } from "@aws-amplify/ui-react";
export default function HeadTableLeads(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: {},
        "Nombre Completo": {},
        "Tel\u00E9fono": {},
        Registro: {},
        Canal: {},
        "Asignaci\u00F3n": {},
        Sucursal: {},
        Descarte: {},
        "Qui\u00E9n descarta": {},
        "Motivo de Descarte": {},
        "Asesor Conekta": {},
        Asesor: {},
        "Atenci\u00F3n": {},
        Fase: {},
        Comentarios: {},
        "Acci\u00F3n": {},
        Detalles: {},
        "Frame 20835": {},
        HeadTableLeads: {},
      },
      variantValues: { type: "asignLider" },
    },
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: { display: "none" },
        "Nombre Completo": {},
        "Tel\u00E9fono": {},
        Registro: {},
        Canal: {},
        "Asignaci\u00F3n": { display: "none" },
        Sucursal: { display: "none" },
        Descarte: { display: "none", children: "Descarte" },
        "Qui\u00E9n descarta": {},
        "Motivo de Descarte": {},
        "Asesor Conekta": {},
        Asesor: { display: "none" },
        "Atenci\u00F3n": { display: "none", children: "Atencion" },
        Fase: { display: "none" },
        Comentarios: { display: "block" },
        "Acci\u00F3n": { display: "block" },
        Detalles: { display: "none" },
        "Frame 20835": {},
        HeadTableLeads: { width: "1536px" },
      },
      variantValues: { type: "forAssign" },
    },
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: { display: "none" },
        "Nombre Completo": {},
        "Tel\u00E9fono": {},
        Registro: {},
        Canal: {},
        "Asignaci\u00F3n": {},
        Sucursal: { display: "none" },
        Descarte: { display: "none", children: "Descarte" },
        "Qui\u00E9n descarta": {},
        "Motivo de Descarte": {},
        "Asesor Conekta": {},
        Asesor: { display: "none" },
        "Atenci\u00F3n": { display: "none", children: "Atencion" },
        Fase: { display: "none" },
        Comentarios: { display: "block" },
        "Acci\u00F3n": {},
        Detalles: { display: "none" },
        "Frame 20835": {},
        HeadTableLeads: { width: "1536px" },
      },
      variantValues: { type: "assing" },
    },
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: { display: "none" },
        "Nombre Completo": {},
        "Tel\u00E9fono": { display: "none" },
        Registro: { display: "none" },
        Canal: {},
        "Asignaci\u00F3n": {},
        Sucursal: {},
        Descarte: { display: "none", children: "Descarte" },
        "Qui\u00E9n descarta": {},
        "Motivo de Descarte": {},
        "Asesor Conekta": { display: "none", children: "Asesor Conekta" },
        Asesor: {},
        "Atenci\u00F3n": {},
        Fase: { children: "Estatus" },
        Comentarios: {},
        "Acci\u00F3n": {},
        Detalles: {},
        "Frame 20835": {},
        HeadTableLeads: { width: "1759px" },
      },
      variantValues: { type: "followup" },
    },
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: { display: "none" },
        "Nombre Completo": {},
        "Tel\u00E9fono": { display: "none" },
        Registro: {},
        Canal: {},
        "Asignaci\u00F3n": { display: "none" },
        Sucursal: { display: "none" },
        Descarte: { children: "Descarte" },
        "Qui\u00E9n descarta": { display: "block" },
        "Motivo de Descarte": { display: "block" },
        "Asesor Conekta": {},
        Asesor: { display: "none" },
        "Atenci\u00F3n": { display: "none", children: "Atencion" },
        Fase: { display: "none" },
        Comentarios: { display: "block" },
        "Acci\u00F3n": {},
        Detalles: { display: "none" },
        "Frame 20835": {},
        HeadTableLeads: { width: "1754px" },
      },
      variantValues: { type: "discarded" },
    },
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: { display: "none" },
        "Nombre Completo": {},
        "Tel\u00E9fono": { display: "none" },
        Registro: { display: "none" },
        Canal: { display: "none" },
        "Asignaci\u00F3n": { display: "none" },
        Sucursal: {},
        Descarte: { children: "Descarte" },
        "Qui\u00E9n descarta": { display: "block" },
        "Motivo de Descarte": { display: "block" },
        "Asesor Conekta": { display: "none", children: "Asesor Conekta" },
        Asesor: {},
        "Atenci\u00F3n": { display: "none", children: "Atencion" },
        Fase: { display: "none" },
        Comentarios: { display: "block" },
        "Acci\u00F3n": {},
        Detalles: {},
        "Frame 20835": {},
        HeadTableLeads: { width: "1754px" },
      },
      variantValues: { type: "discardedmanager" },
    },
    {
      overrides: {
        Divider: {},
        ID: {},
        Estatus: { display: "none" },
        "Nombre Completo": {},
        "Tel\u00E9fono": {},
        Registro: { display: "none" },
        Canal: {},
        "Asignaci\u00F3n": {},
        Sucursal: { display: "none" },
        Descarte: { children: "Gerencia" },
        "Qui\u00E9n descarta": {
          display: "block",
          children: "Fecha de asignaci\u00F3n",
        },
        "Motivo de Descarte": {
          display: "block",
          children: "Asignado a Asesor",
        },
        "Asesor Conekta": { display: "none", children: "Atenci\u00F3n Asesor" },
        Asesor: {},
        "Atenci\u00F3n": {},
        Fase: { display: "none" },
        Comentarios: { display: "block" },
        "Acci\u00F3n": { display: "block", children: "Estatus" },
        Detalles: {},
        "Frame 20835": {},
        HeadTableLeads: { width: "2560px" },
      },
      variantValues: { type: "assignmanager" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="15px"
      direction="column"
      width="2850px"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 15px 0px"
      display="flex"
      {...getOverrideProps(overrides, "HeadTableLeads")}
      {...rest}
    >
      <Divider
        width="unset"
        height="1px"
        shrink="0"
        alignSelf="stretch"
        size="small"
        orientation="horizontal"
        {...getOverrideProps(overrides, "Divider")}
      ></Divider>
      <Flex
        gap="16px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        display="flex"
        {...getOverrideProps(overrides, "Frame 20835")}
      >
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="none"
          direction="column"
          justifyContent="unset"
          width="90px"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="ID"
          {...getOverrideProps(overrides, "ID")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Estatus"
          {...getOverrideProps(overrides, "Estatus")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Nombre Completo"
          {...getOverrideProps(overrides, "Nombre Completo")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Teléfono"
          {...getOverrideProps(overrides, "Tel\u00E9fono")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Registro"
          {...getOverrideProps(overrides, "Registro")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Canal"
          {...getOverrideProps(overrides, "Canal")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Asignación"
          {...getOverrideProps(overrides, "Asignaci\u00F3n")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Sucursal"
          {...getOverrideProps(overrides, "Sucursal")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Reasignaciones"
          {...getOverrideProps(overrides, "Descarte")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="none"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Quién descarta"
          {...getOverrideProps(overrides, "Qui\u00E9n descarta")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="none"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Motivo de Descarte"
          {...getOverrideProps(overrides, "Motivo de Descarte")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Contact Center"
          {...getOverrideProps(overrides, "Asesor Conekta")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Asesor"
          {...getOverrideProps(overrides, "Asesor")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Atención"
          {...getOverrideProps(overrides, "Atenci\u00F3n")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Fase"
          {...getOverrideProps(overrides, "Fase")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="none"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Comentarios"
          {...getOverrideProps(overrides, "Comentarios")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="none"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Acción"
          {...getOverrideProps(overrides, "Acci\u00F3n")}
        ></Text>
        <Text
          fontFamily="Inter"
          fontSize="20px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="30px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          grow="1"
          shrink="1"
          basis="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Detalles"
          {...getOverrideProps(overrides, "Detalles")}
        ></Text>
      </Flex>
    </Flex>
  );
}
